import React from 'react';
import CandidatesPageLayout from '../../components/CandidatesPageLayout';
import AiSearchNavigationSidebar from './AiSearchNavigationSidebar';

const AiSearchPage = ({ children }: React.PropsWithChildren) => {
    return <CandidatesPageLayout sidebar={<AiSearchNavigationSidebar />}>{children}</CandidatesPageLayout>;
};

export default AiSearchPage;
